module.exports = "<style>\n  <%- cssVariables -%>\n</style>\n"